export default __webpack_public_path__ + "static/media/490.a8eb252a.png";